<script setup lang="ts">
import type { Component } from "vue";

import {
  BsBoxSeam as Box,
  BsCurrencyEuro as Euro,
  CdGear as Gear,
  AkCircleCheck as Check,
  AnOutlinedPlayCircle as Play,
  AkInfo as Info,
  IcVideoCamera as Camera,
  AkCalendar as Calendar,
  BsSearch as Search,
  AkClock as Clock,
  BsFlag as Flag,
  AkLocation as Location,
  BsChevronCompactDown as ArrowDown,
  BxFilterAlt as Filter,
  AkEyeOpen as Eye,
  CaLayers as Layers,
  AnOutlinedUpload as Upload,
  FlDelete as Delete,
  TaOutlineReplace as ReplaceImage,
  BxSortAlt2 as SortNeutral,
  AnOutlinedSortAscending as SortAsc,
  AnOutlinedSortDescending as SortDes,
  AnOutlinedEdit as Edit,
  AkDashboard as Dashboard,
  ChChartBar as ChartBar,
  FaClipboardList as Clipboard,
  FaRegCalendarCheck as CalendarCheck,
  CaAddLarge as Add,
  AnOutlinedPicture as Picture,
  AnOutlinedClose as Close,
  FlRocket as Rocket,
  MiLogout as Logout,
  AnOutlinedBarChart as BarChart,
  CaPercentage as Percentage,
  AkTriangleUpFill as TriangleUp,
  BxSave as Save,
  AnFilledWarning as Warning,
  BsShieldCheck as ShieldCheck,
  ClUsers as Users,
  MdDriveFileRenameOutline as Pencil,
  MdOutlinedCancel as Cancel,
  AnOutlinedFile as File,
  AkImage as Image,
  CaDocumentDownload as DownloadFile,
} from "@kalimahapps/vue-icons";
const Icons = {
  Euro,
  Gear,
  Box,
  Check,
  Play,
  Info,
  Camera,
  Calendar,
  Search,
  Clock,
  Flag,
  Location,
  ArrowDown,
  Filter,
  Eye,
  Layers,
  Upload,
  Delete,
  ReplaceImage,
  SortNeutral,
  SortAsc,
  SortDes,
  Edit,
  Dashboard,
  ChartBar,
  Clipboard,
  CalendarCheck,
  Add,
  Picture,
  Close,
  Rocket,
  Logout,
  BarChart,
  Percentage,
  TriangleUp,
  Save,
  Warning,
  ShieldCheck,
  Users,
  Pencil,
  Cancel,
  File,
  Image,
  DownloadFile,
} satisfies Record<string, Component>;

export type IconName = keyof typeof Icons;

const props = defineProps<{
  name: keyof typeof Icons;
}>();
</script>

<template>
  <component :is="Icons[props.name]" v-bind="$attrs" />
</template>
